import { adjustProjectDateForDisplay } from "./date-utils";

interface DateRangeBoundsArgs {
  startDate: Date | string | null | undefined;
  endDate: Date | string | null | undefined;
}

interface DateRangeBounds {
  maxSelectableStartDate: Date | undefined;
  minSelectableEndDate: Date | undefined;
}

/**
 * Bounds for a `startDate` / `endDate` picker pair, in display space.
 *
 * The range is inclusive — a pair on the same day is one day long — so each
 * bound is the other date itself rather than a day inside it.
 */
export function getDateRangeBounds({ startDate, endDate }: DateRangeBoundsArgs): DateRangeBounds {
  return {
    maxSelectableStartDate: adjustProjectDateForDisplay(endDate) ?? undefined,
    minSelectableEndDate: adjustProjectDateForDisplay(startDate) ?? undefined,
  };
}
